module.exports = __webpack_public_path__ + "img/icn_voto_mesas_white.ef4bde0d.svg";